// extracted by mini-css-extract-plugin
export default {"profileNavLinks":"NavList_profileNavLinks__AVHdi","active":"NavList_active__WaoVg"};